"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
exports.__esModule = true;
var angular = require("angular");
require('../learning-plan-new/new-learning-plan.component.css');
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var ISSUE_TYPE_COLOR = {
    Discovery: "#FFEAF4",
    Specify: "#FFFFB7",
    Navigate: "#C6DCFB",
    Manage: "#CFFFEE"
};
function discoveryGrid(ignorance, impact) {
    return ignorance >= 5 && impact >= 5
        ? "Discovery"
        : ignorance >= 5 && impact < 5
            ? "Specify"
            : ignorance < 5 && impact >= 5
                ? "Navigate"
                : "Manage";
}
var NewLearningPlanComponent = /** @class */ (function () {
    function NewLearningPlanComponent($rootScope, $scope, $timeout) {
        this.initLearningPlanSection = 4;
        this.unPlannedData = [];
        this.issueConfig = {};
        this.disableEdit = false;
        this.sectionNames = [];
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.$rootScope = $rootScope;
        ctrl.dashboardExpPriority = false;
        ctrl.selectedForAct = -1;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DFV);
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.showGenerateBtn = false;
        ctrl.guideCommand = '';
        ctrl.stopLoadingSpinner = function () {
            $scope.$emit('workbench:loading', { 'load': false });
        };
        $scope.$on('command:NEW_LEARNING_PLAN', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.guideCommand = '';
            ctrl.initLearningPlanSection = args.initLearningPlanSection;
            ctrl.isDataLoaded = false;
            ctrl.sectionNames = args.sectionNames;
            ctrl.initComponent(event, args);
            ctrl.getNColCanvasConfig();
            ctrl.clearDivs();
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    NewLearningPlanComponent.prototype.getNColCanvasConfig = function () {
        var ctrl = this;
        var config = ctrl.utilsService.getIssueConfigFromStorage(true);
        ctrl.issueConfig = config.issueConfig;
        ctrl.display = config.title;
    };
    NewLearningPlanComponent.prototype.setGlobalDirty = function () {
        var ctrl = this;
        ctrl.$timeout(function () {
            ctrl.$rootScope.smartorgDirty = ctrl.isDirty;
        }, 0);
    };
    NewLearningPlanComponent.prototype.setWarningDialog = function () {
        var ctrl = this;
        ctrl.warningOpen = { "show": true };
    };
    NewLearningPlanComponent.prototype.setMoveWarningDialog = function (actionGot) {
        var ctrl = this;
        ctrl.warningOpen = { "showMove": true, "action": actionGot, "context": this };
    };
    NewLearningPlanComponent.prototype.addInActive = function () {
        var ctrl = this;
        var issueGot = ctrl.selectedFrom[ctrl.selectedIndex];
        console.log(issueGot.startExp);
        if (issueGot.startExp != undefined && issueGot.startExp !== '') {
            var startExp = new Date(issueGot.startExp);
            var estDate = new Date();
            estDate.setDate(startExp.getDate() + issueGot.duration * 7);
            ctrl.currExperiment['status'] = ctrl.origStatus[4];
            ctrl.currExperiment['estCompDate'] = moment(estDate).format("DD-MMM-YYYY");
            ctrl.currExperiment['startActiveDate'] = moment(startExp).format("DD-MMM-YYYY");
            ctrl.currExperiment['ignoranceBefore'] = ctrl.currExperiment['ignorance'];
            ctrl.currExperiment['impactBefore'] = ctrl.currExperiment['impact'];
            ctrl.currExperiment['calcImpactBefore'] = ctrl.currExperiment['calcImpact'];
            ctrl.currExperiment['scoreBefore'] = ctrl.currExperiment['score'];
            ctrl.currExperiment['costBefore'] = ctrl.currExperiment['cost'];
            ctrl.currExperiment['resourceFteBefore'] = ctrl.currExperiment['resourceFte'];
            ctrl.currExperiment['resFteBefore'] = ctrl.currExperiment['resFte'];
            ctrl.currExperiment['totalCostBefore'] = ctrl.currExperiment['totalCost'];
            ctrl.currExperiment['durationBefore'] = ctrl.currExperiment['duration'];
            ctrl.currExperiment['issueColorBefore'] = ctrl.currExperiment['issueColor'];
            ctrl.currExperiment['issueTypeBefore'] = ctrl.currExperiment['issueType'];
            ctrl.currExperiment['impactMappingListBefore'] = ctrl.currExperiment['impactMappingList'];
            ctrl.currExperiment['abilityToLaunchBefore'] = ctrl.currExperiment['abilityToLaunch'];
            ctrl.currExperiment['isPotentialShowStopperBefore'] = ctrl.currExperiment['isPotentialShowStopper'];
            ctrl.saveCurrentExp();
        }
        else {
            ctrl.warningOpen['msg'] = "Please provide the date";
        }
    };
    NewLearningPlanComponent.prototype.addInBacklog = function () {
        var ctrl = this.context;
        var issueGot = ctrl.selectedFrom[ctrl.selectedIndex];
        ctrl.currExperiment['status'] = ctrl.origStatus[2];
        ctrl.saveCurrentExp();
    };
    NewLearningPlanComponent.prototype.addInInPlan = function () {
        var ctrl = this.context;
        var issueGot = ctrl.selectedFrom[ctrl.selectedIndex];
        ctrl.currExperiment['status'] = ctrl.origStatus[1];
        ctrl.currExperiment['startDatePotential'] = ctrl.utilsService.updatedAt();
        ctrl.saveCurrentExp();
    };
    NewLearningPlanComponent.prototype.addInCompleted = function () {
        var ctrl = this;
        var issueGot = ctrl.selectedFrom[ctrl.selectedIndex];
        ctrl.currExperiment['status'] = ctrl.origStatus[0];
        ctrl.currExperiment['actualCompDate'] = moment(ctrl.utilsService.updatedAt()).format("DD-MMM-YYYY");
        ctrl.saveCurrentExp();
    };
    NewLearningPlanComponent.prototype.recalcoverAllInplan = function (issueGot) {
        var ctrl = this;
        if (ctrl.inPlanData.length != 1) {
            ctrl.inPlanData[ctrl.inPlanData.length - 1].duration -= issueGot.duration;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].score -= issueGot.score;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].totalCost -= issueGot.totalCost;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].totalCost = Math.round(ctrl.inPlanData[ctrl.inPlanData.length - 1].totalCost * 100) / 100;
            var latestDate_1 = null;
            ctrl.inPlanData.map(function (i, k) {
                if (k != ctrl.inPlanData.length - 1) {
                    var prevDate = new Date(latestDate_1);
                    var newDate = new Date(i.potentialDate);
                    if (newDate > prevDate) {
                        latestDate_1 = newDate;
                    }
                }
            });
            ctrl.inPlanData[ctrl.inPlanData.length - 1].potentialDate = moment(latestDate_1).format("DD-MMM-YYYY");
        }
        else {
            ctrl.inPlanData[ctrl.inPlanData.length - 1].duration = 0;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].score = 0;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].totalCost = 0;
            ctrl.inPlanData[ctrl.inPlanData.length - 1].potentialDate = "";
        }
    };
    NewLearningPlanComponent.prototype.recalcoverAllActive = function (issueGot) {
        var ctrl = this;
        if (ctrl.activeData.length == 1) {
            ctrl.activeData.push({ expName: "OverAll" });
            ctrl.activeData[ctrl.activeData.length - 1].duration = issueGot.duration;
            ctrl.activeData[ctrl.activeData.length - 1].score = issueGot.score;
            ctrl.activeData[ctrl.activeData.length - 1].totalCost = issueGot.totalCost;
            ctrl.activeData[ctrl.activeData.length - 1].estCompDate = issueGot.estCompDate;
        }
        else if (ctrl.activeData.length > 1) {
            ctrl.activeData[ctrl.activeData.length - 1].duration += issueGot.duration;
            ctrl.activeData[ctrl.activeData.length - 1].score += issueGot.score;
            ctrl.activeData[ctrl.activeData.length - 1].totalCost += issueGot.totalCost;
            ctrl.activeData[ctrl.activeData.length - 1].totalCost = Math.round(ctrl.activeData[ctrl.activeData.length - 1].totalCost * 100) / 100;
            var latestDate_2 = null;
            ctrl.activeData.map(function (i, k) {
                if (k != ctrl.activeData.length - 1) {
                    var prevDate = new Date(latestDate_2);
                    var newDate = new Date(i.estCompDate);
                    if (newDate > prevDate) {
                        latestDate_2 = newDate;
                    }
                }
            });
            ctrl.activeData[ctrl.activeData.length - 1].estCompDate = moment(latestDate_2).format("DD-MMM-YYYY");
        }
    };
    NewLearningPlanComponent.prototype.closeWarningDialog = function () {
        var ctrl = this;
        ctrl.warningOpen = { "show": false };
    };
    NewLearningPlanComponent.prototype.closeMoveWarningDialog = function () {
        var ctrl = this;
        ctrl.warningOpen = { "showMove": false };
    };
    NewLearningPlanComponent.prototype.sliderChange = function () {
        var ctrl = this;
        // Use the correct impact value based on qualitative mode
        var impactToBeUsed = ctrl.isQualitative ? ctrl.currExperiment.impact : ctrl.currExperiment.calcImpact;
        // Update score, issueColor and issueType
        ctrl.currExperiment.score = impactToBeUsed * ctrl.currExperiment.ignorance;
        ctrl.currExperiment.issueColor = this.utilsService.zoneColor[ctrl.getDiscoveryGrid(ctrl.currExperiment.ignorance, impactToBeUsed).replace(/ /g, "")];
        ctrl.currExperiment.issueType = this.utilsService.discoveryGridSCase(ctrl.currExperiment.ignorance, impactToBeUsed);
        ctrl.checkSave();
    };
    NewLearningPlanComponent.prototype.getDiscoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "DISCOVERY"
            : ignorance >= 5 && impact < 5
                ? "SPECIFY"
                : ignorance < 5 && impact >= 5
                    ? "NAVIGATE"
                    : "MANAGE";
    };
    NewLearningPlanComponent.prototype.getStandardSettings = function () {
        return {
            readOnly: true,
            filters: true,
            dropdownMenu: [
                "filter_by_value",
                "filter_action_bar",
                "filter_by_condition",
            ],
            rowHeaders: false,
            stretchH: "all",
            width: "85vw",
            licenseKey: this.smartorg.handsonTableLicenseKey,
            viewportColumnRenderingOffset: 70,
            columnSorting: true
        };
    };
    NewLearningPlanComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem ? args.actionMenuItem : "New Learning Plan";
        ctrl.distInputs = [];
        ctrl.radioOrCheckbox = '';
        ctrl.inputTypeLt = '';
        ctrl.npvData = [];
        ctrl.settingsBacklog = __assign({}, ctrl.getStandardSettings(), { cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = (col == 0) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 2) {
                    cellPrp.renderer = ctrl.IssueTypeRenderer;
                }
                if (col === 7 && !ctrl.disableEdit) {
                    cellPrp.context = ctrl;
                    cellPrp.renderer = ctrl.moveRendererBacklog;
                }
                return cellPrp;
            }, colWidths: [10, 10, 10, 10, 10, 10, 10, 5], afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 0) {
                    ctrl.selectIssue(indexGotHere, ctrl.backlogData);
                }
                ctrl.$scope.$apply();
            }, afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            } });
        ctrl.settingsInCompleted = __assign({}, ctrl.getStandardSettings(), { cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = ((col == 0 || col == 9) && row != ctrl.compltData.length - 1) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 2) {
                    cellPrp.renderer = ctrl.IssueTypeRendererInplan;
                }
                if (col === 7 && !ctrl.disableEdit) {
                    cellPrp.context = ctrl;
                    cellPrp.renderer = ctrl.ResultRenderer;
                }
                if (!ctrl.disableEdit && col === 9 && row !== ctrl.compltData.length - 1) {
                    // if (col === 8 && row !== ctrl.compltData.length - 1) {
                    cellPrp.context = ctrl;
                    cellPrp.renderer = ctrl.moveFromCompleteRenderer;
                }
                return cellPrp;
            }, colWidths: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10], afterColumnSort: function (currentSortCfg, destSortCfg) {
                this.rowIndexMapper.moveIndexes([this.toVisualRow(ctrl.compltData.length - 1)], ctrl.compltData.length - 1);
            }, afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                // if (coords.col == 0 && coords.row !== ctrl.compltData.length - 1) {
                if (coords.col == 0) {
                    ctrl.selectIssue(indexGotHere, ctrl.compltData);
                }
                ctrl.$scope.$apply();
            }, afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4 || col === 9) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            } });
        ctrl.settingsInPlan = __assign({}, ctrl.getStandardSettings(), { cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = ((col == 0 || col == 8) && row != ctrl.inPlanData.length - 1) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 2) {
                    cellPrp.renderer = ctrl.IssueTypeRendererInplan;
                }
                if (!ctrl.disableEdit && col === 8 && row !== ctrl.inPlanData.length - 1) {
                    cellPrp.context = ctrl;
                    cellPrp.renderer = ctrl.moveRenderer;
                }
                return cellPrp;
            }, colWidths: [10, 10, 10, 10, 10, 7, 10, 10, 5], afterColumnSort: function (currentSortCfg, destSortCfg) {
                this.rowIndexMapper.moveIndexes([this.toVisualRow(ctrl.inPlanData.length - 1)], ctrl.inPlanData.length - 1);
            }, afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 0 && coords.row !== ctrl.inPlanData.length - 1) {
                    ctrl.selectIssue(indexGotHere, ctrl.inPlanData);
                }
            }, afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4 || col === 8) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            } });
        ctrl.settingsInActive = __assign({}, ctrl.getStandardSettings(), { cells: function (row, col) {
                var cellPrp = {};
                cellPrp.className = (col == 0) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                cellPrp.className = ((col == 0 || col == 8) && row != ctrl.activeData.length - 1) ? 'htLeft htMiddle cursor-pointer' : 'htCenter htMiddle';
                if (col === 2) {
                    cellPrp.renderer = ctrl.IssueTypeRendererInplan;
                }
                if (!ctrl.disableEdit && col === 8 && row !== ctrl.activeData.length - 1) {
                    cellPrp.context = ctrl;
                    cellPrp.renderer = ctrl.moveCompleteRenderer;
                }
                return cellPrp;
            }, colWidths: [10, 10, 10, 10, 10, 10, 10, 10, 5], afterOnCellMouseDown: function (event, coords) {
                var indexGotHere = this.toPhysicalRow(coords.row);
                if (coords.col == 0 && coords.row !== ctrl.activeData.length - 1) {
                    ctrl.selectIssue(indexGotHere, ctrl.activeData);
                }
                ctrl.$scope.$apply();
            }, afterGetColHeader: function (col, TH) {
                if (col === 2 || col === 4) {
                    var button = TH.querySelector(".changeType");
                    if (!button) {
                        return;
                    }
                    button.parentElement.removeChild(button);
                }
            },
            afterColumnSort: function (currentSortCfg, destSortCfg) {
                this.rowIndexMapper.moveIndexes([this.toVisualRow(ctrl.activeData.length - 1)], ctrl.activeData.length - 1);
            } });
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        // Initialize to false, will be properly set in getIssueDetailsFromDb
        ctrl.isQualitative = false;
        ctrl.fteGlobal = args.fte;
        ctrl.tornadoFactors = args.factors;
        ctrl.tornadoFactors.forEach(function (f) {
            f['Comment'] = decodeURIComponent(f['Comment']);
        });
        ctrl.tornadoFactors = ctrl.tornadoFactors.concat([
            { 'Factor': 'Chance of Failure - High (75% to 100%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Middle (Around 50%)', 'Comment': '' },
            { 'Factor': 'Chance of Failure - Low (Less than 25%)', 'Comment': '' }
        ]);
        ctrl.origTornadoFactors = angular.copy(ctrl.tornadoFactors);
        ctrl.origStatus = ["Completed", "In Plan", "Backlog", "Unplanned", "Active"];
        ctrl.node = args.node;
        ctrl.issueData = [];
        ctrl.compltData = [];
        ctrl.inPlanData = [];
        ctrl.activeData = [];
        ctrl.backlogData = [];
        ctrl.unPlannedData = [];
        ctrl.selectedIssue = null;
        ctrl.isDirty = false;
        ctrl.getIssueDetailsFromDb();
        ctrl.menu = [];
        ctrl.setGlobalDirty();
        ctrl.sliderOptionsIgnorance = {
            stepsArray: [
                { value: 1 },
                { value: 2, legend: 'Routine' },
                { value: 3 },
                { value: 4 },
                { value: 5, legend: 'Uncomfortable' },
                { value: 6 },
                { value: 7 },
                { value: 8, legend: 'Speculative' },
                { value: 9 }
            ],
            showTicks: true,
            showTicksValues: true
        };
        ctrl.sliderOptionsIgnoranceBefore = {
            stepsArray: [
                { value: 1 },
                { value: 2, legend: 'Routine' },
                { value: 3 },
                { value: 4 },
                { value: 5, legend: 'Uncomfortable' },
                { value: 6 },
                { value: 7 },
                { value: 8, legend: 'Speculative' },
                { value: 9 }
            ],
            showTicks: true,
            showTicksValues: true,
            disabled: true
        };
        // ctrl.sliderChange()
    };
    NewLearningPlanComponent.prototype.showTable = function (issueData) {
        var ctrl = this;
        ctrl.clearDivs();
        ctrl.loadHotTableConfig();
        ctrl.isDataLoaded = true;
        var overAllSummaryInPlan = { duration: 0, score: 0, totalCost: 0, potentialDate: null };
        var overAllSummaryInActive = { duration: 0, score: 0, totalCost: 0, estCompDate: null };
        var overAllSummaryInCompleted = { score: 0, totalCost: 0 };
        issueData.map(function (i, k) {
            console.log(i.status + "--" + ctrl.origStatus[2]);
            if (i.status == ctrl.origStatus[0]) {
                overAllSummaryInCompleted.score += i.score;
                overAllSummaryInCompleted.totalCost += i.totalCost;
                ctrl.compltData.push(__assign({}, i, { origIndex: k }));
            }
            else if (i.status == ctrl.origStatus[1]) {
                var potentialDate = new Date(i.startDatePotential);
                console.log("Date was:" + potentialDate + "--Duration was:" + i.duration);
                potentialDate.setDate(potentialDate.getDate() + i.duration * 7);
                console.log("Date is now:" + potentialDate);
                if (overAllSummaryInPlan.duration < i.duration) {
                    overAllSummaryInPlan.duration = i.duration;
                }
                overAllSummaryInPlan.score += i.score;
                overAllSummaryInPlan.totalCost += i.totalCost;
                var prevDate = new Date(overAllSummaryInPlan.potentialDate);
                var newDate = new Date(potentialDate);
                if (newDate > prevDate) {
                    overAllSummaryInPlan.potentialDate = moment(newDate).format("DD-MMM-YYYY");
                }
                ctrl.inPlanData.push(__assign({}, i, { origIndex: k, potentialDate: moment(potentialDate).format("DD-MMM-YYYY") }));
            }
            else if (i.status == ctrl.origStatus[2]) {
                ctrl.backlogData.push(__assign({}, i, { origIndex: k, comment: i.comment ? i.comment : '' }));
            }
            else if (i.status == ctrl.origStatus[3]) {
                ctrl.unPlannedData.push(__assign({}, i, { origIndex: k }));
            }
            else if (i.status == ctrl.origStatus[4]) {
                if (overAllSummaryInActive.duration < i.duration) {
                    overAllSummaryInActive.duration = i.duration;
                }
                overAllSummaryInActive.score += i.score;
                overAllSummaryInActive.totalCost += i.totalCost;
                var estDate = new Date(i.startActiveDate);
                estDate.setDate(estDate.getDate() + i.duration * 7);
                i.estCompDate = estDate;
                var prevDate = new Date(overAllSummaryInActive.estCompDate);
                var newDate = new Date(i.estCompDate);
                if (newDate > prevDate) {
                    overAllSummaryInActive.estCompDate = moment(newDate).format("DD-MMM-YYYY");
                }
                ctrl.activeData.push(__assign({}, i, { origIndex: k, estCompDate: moment(i.estCompDate).format("DD-MMM-YYYY") }));
            }
        });
        ctrl.inPlanData.push(__assign({ expName: "OverAll" }, overAllSummaryInPlan, { totalCost: Math.round(overAllSummaryInPlan.totalCost * 100) / 100 }));
        ctrl.compltData.push(__assign({ expName: "OverAll" }, overAllSummaryInCompleted, { totalCost: Math.round(overAllSummaryInCompleted.totalCost * 100) / 100 }));
        if (ctrl.activeData.length > 0) {
            ctrl.activeData.push(__assign({ isSummary: true, expName: "OverAll" }, overAllSummaryInActive, { totalCost: Math.round(overAllSummaryInActive.totalCost * 100) / 100 }));
        }
        var backlogTable = document.getElementById('backlog-table');
        var inplanTable = document.getElementById('inplan-table');
        var activeTable = document.getElementById('active-table');
        var completedTable = document.getElementById('completed-table');
        var hotBacklog = new Handsontable(backlogTable, __assign({}, ctrl.settingsBacklog, { colHeaders: ctrl.colHeaders, columns: ctrl.columns, data: ctrl.backlogData, height: 'auto' }));
        var hotInplan = new Handsontable(inplanTable, __assign({}, ctrl.settingsInPlan, { colHeaders: ctrl.colHeadersInPlan, columns: ctrl.columnsInPlan, data: ctrl.inPlanData, height: 'auto' }));
        var hotActive = new Handsontable(activeTable, __assign({}, ctrl.settingsInActive, { colHeaders: ctrl.colHeadersInActive, columns: ctrl.columnsInActive, data: ctrl.activeData, height: 'auto' }));
        var hotCompleted = new Handsontable(completedTable, __assign({}, ctrl.settingsInCompleted, { colHeaders: ctrl.colHeadersInCompleted, columns: ctrl.columnsInCompleted, data: ctrl.compltData, height: 'auto' }));
        ctrl.hotInActiveInstance = hotActive.getInstance();
        ctrl.hotInPlanInstance = hotInplan.getInstance();
    };
    NewLearningPlanComponent.prototype.loadHotTableConfig = function () {
        var ctrl = this;
        ctrl.dropdownMenu = [
            "filter_by_value",
            "filter_action_bar",
            "filter_by_condition",
        ];
        ctrl.colHeaders = [
            "Experiment",
            "Issue",
            "Issue Type",
            "Surprise Index",
            "Est. Cost $K",
            "Duration Weeks",
            "Comments",
            "Move"
        ];
        ctrl.colHeadersInPlan = [
            "Experiment",
            "Issue",
            "Issue Type",
            "Surprise Index",
            "Est. Cost $K",
            "Duration Weeks",
            "Potential Completion",
            "Comments",
            "Move"
        ];
        ctrl.colHeadersInCompleted = [
            "Experiment",
            "Issue",
            "Zone",
            "Surprise Index",
            "Actual Cost $K",
            "Actual Duration Weeks",
            "Actual Completion",
            "Result",
            "Comments",
            "Move"
        ];
        ctrl.colHeadersInActive = [
            "Experiment",
            "Issue",
            "Issue Type",
            "Surprise Index",
            "Est. Cost $K",
            "Est. Duration Weeks",
            "Est. Completion Date",
            "Comments",
            "Move"
        ];
        ctrl.colWidths = ["25vw", "15vw", "15vw", "25vw", "15vw", "15vw", "35vw"];
        // height: "60vh",
        // width: "70vw",
        ctrl.columns = [
            { data: "expName", className: "htCenter htMiddle" },
            { data: "name", className: "htLeft htMiddle cursor-pointer" },
            { data: "issueType", className: "htCenter htMiddle" },
            { data: "score", className: "htCenter htMiddle" },
            { data: "totalCost", className: "htCenter htMiddle" },
            { data: "duration", className: "htCenter htMiddle" },
            { data: "comment", className: "htCenter htMiddle" },
            { data: "move", className: "htCenter htMiddle" },
        ];
        ctrl.columnsInPlan = [
            { data: "expName", className: "htCenter htMiddle" },
            { data: "name", className: "htLeft htMiddle cursor-pointer" },
            { data: "issueType", className: "htCenter htMiddle" },
            { data: "score", className: "htCenter htMiddle" },
            { data: "totalCost", className: "htCenter htMiddle" },
            { data: "duration", className: "htCenter htMiddle" },
            { data: "potentialDate", className: "htCenter htMiddle" },
            { data: "comment", className: "htCenter htMiddle" },
            { data: "move", className: "htCenter htMiddle" },
        ];
        ctrl.columnsInActive = [
            { data: "expName", className: "htCenter htMiddle" },
            { data: "name", className: "htLeft htMiddle cursor-pointer" },
            { data: "issueType", className: "htCenter htMiddle" },
            { data: "score", className: "htCenter htMiddle" },
            { data: "totalCost", className: "htCenter htMiddle" },
            { data: "duration", className: "htCenter htMiddle" },
            { data: "estCompDate", className: "htCenter htMiddle" },
            { data: "comment", className: "htCenter htMiddle" },
            { data: "move", className: "htCenter htMiddle" },
        ];
        ctrl.columnsInCompleted = [
            { data: "expName", className: "htCenter htMiddle" },
            { data: "name", className: "htLeft htMiddle cursor-pointer" },
            { data: "issueType", className: "htCenter htMiddle" },
            { data: "score", className: "htCenter htMiddle" },
            { data: "totalCost", className: "htCenter htMiddle" },
            { data: "duration", className: "htCenter htMiddle" },
            { data: "actualCompDate", className: "htCenter htMiddle" },
            { data: "result", className: "htCenter htMiddle" },
            { data: "comment", className: "htCenter htMiddle" },
            { data: "move", className: "htCenter htMiddle" },
        ];
    };
    NewLearningPlanComponent.prototype.clearDivs = function () {
        try {
            document.getElementById('backlog-table').innerHTML = "";
            document.getElementById('inplan-table').innerHTML = "";
            document.getElementById('active-table').innerHTML = "";
            document.getElementById('completed-table').innerHTML = "";
        }
        catch (e) {
        }
    };
    NewLearningPlanComponent.prototype.IssueTypeRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            td.style.backgroundColor = ISSUE_TYPE_COLOR[value.replace(/ /g, "")];
        }
    };
    NewLearningPlanComponent.prototype.ResultRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            td.classList.add(value);
            td.innerHTML = value.toLowerCase().charAt(0).toUpperCase() + value.slice(1);
        }
    };
    NewLearningPlanComponent.prototype.IssueTypeRendererInplan = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = this;
        // let discoveryQuadrant = {
        //     Discovery: "#FFEAF4",
        //     Specify: "#FFFFB7",
        //     Navigate: "#C6DCFB",
        //     Manage: "#CFFFEE",
        // };
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        if (value) {
            td.style.backgroundColor = ISSUE_TYPE_COLOR[value.replace(/ /g, "")];
        }
        // console.log(value, discoveryQuadrant[value.replace(/ /g, "")]);
    };
    NewLearningPlanComponent.prototype.moveRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = cellProperties.context;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        var valueUP = document.createElement('p');
        valueUP.innerHTML = "<i style='color: black' class='fa fa-arrow-up fa-lg '></i> ";
        valueUP.className = 'move-to-active';
        valueUP.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectIssueForActive(indexGotHere, ctrl.inPlanData);
            // ctrl.$scope.$apply();
        };
        var valueDOWN = document.createElement('p');
        valueDOWN.innerHTML = "<i style='color: black' class='fa fa-arrow-down fa-lg  '></i>";
        valueDOWN.className = 'move-to-active';
        valueDOWN.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectIssueForBacklog(indexGotHere);
            // ctrl.$scope.$apply();
        };
        divMain.appendChild(valueUP);
        divMain.appendChild(valueDOWN);
        divMain.className = "arrows-sec";
        td.appendChild(divMain);
    };
    NewLearningPlanComponent.prototype.moveRendererBacklog = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = cellProperties.context;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        var valueUP = document.createElement('p');
        valueUP.innerHTML = "<i style='color: black' class='fa fa-arrow-up fa-lg  '></i> ";
        valueUP.className = 'move-to-active';
        valueUP.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectIssueForInPlan(indexGotHere, ctrl.backlogData);
            // ctrl.$scope.$apply();
        };
        divMain.appendChild(valueUP);
        divMain.className = "arrows-sec";
        td.appendChild(divMain);
    };
    NewLearningPlanComponent.prototype.moveFromCompleteRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        var ctrl = cellProperties.context;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        var valueDOWN = document.createElement('p');
        valueDOWN.innerHTML = "<i style='color: black' class='fa fa-arrow-down fa-lg '></i>";
        valueDOWN.className = 'move-to-active';
        valueDOWN.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectIssueForActive(indexGotHere, ctrl.compltData);
        };
        divMain.appendChild(valueDOWN);
        divMain.className = "arrows-sec";
        td.appendChild(divMain);
    };
    NewLearningPlanComponent.prototype.moveCompleteRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        // Handsontable.renderers.TextRenderer.apply(this, arguments);
        // td.innerHTML = '';
        // var divMain = document.createElement('DIV');
        // var valuePara = document.createElement('p');
        // valuePara.innerHTML = "Move to Complete"
        // valuePara.className = 'move-to-active'
        // divMain.appendChild(valuePara)
        // td.appendChild(divMain);
        var ctrl = cellProperties.context;
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        var valueUP = document.createElement('p');
        valueUP.innerHTML = "<i style='color: black' class='fa fa-arrow-up fa-lg  '></i> ";
        valueUP.className = 'move-to-active';
        valueUP.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectedForComp = indexGotHere;
            ctrl.selectIssueForCompleted(indexGotHere, ctrl.activeData);
            // ctrl.$scope.$apply();
        };
        var valueDOWN = document.createElement('p');
        valueDOWN.innerHTML = "<i style='color: black' class='fa fa-arrow-down fa-lg '></i>";
        valueDOWN.className = 'move-to-active';
        valueDOWN.onclick = function () {
            var indexGotHere = instance.toPhysicalRow(row);
            ctrl.selectIssueForInPlan(indexGotHere, ctrl.activeData);
        };
        divMain.appendChild(valueUP);
        divMain.appendChild(valueDOWN);
        divMain.className = "arrows-sec";
        td.appendChild(divMain);
    };
    NewLearningPlanComponent.prototype.myRenderer = function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.TextRenderer.apply(this, arguments);
        td.innerHTML = '';
        var divMain = document.createElement('DIV');
        divMain.className = 'process-back';
        var valuePara = document.createElement('p');
        valuePara.className = 'process-value';
        valuePara.innerHTML = value + " %";
        var div = document.createElement('DIV');
        div.className = 'process';
        div.style.width = value + '%';
        divMain.appendChild(valuePara);
        divMain.appendChild(div);
        td.appendChild(divMain);
    };
    NewLearningPlanComponent.prototype.discoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "Discovery"
            : ignorance >= 5 && impact < 5
                ? "Specify"
                : ignorance < 5 && impact >= 5
                    ? "Navigate"
                    : "Manage";
    };
    NewLearningPlanComponent.prototype.selectFactor = function () {
        var ctrl = this;
        ctrl.currExperiment.issueFactor = ctrl.selectedFactor;
        ctrl.checkSave();
    };
    NewLearningPlanComponent.prototype.selectStatus = function () {
        var ctrl = this;
        ctrl.currExperiment.status = ctrl.selectedStatus;
        ctrl.checkSave();
    };
    NewLearningPlanComponent.prototype.isCompleted = function () {
        var ctrl = this;
        return ctrl.currExperiment && ctrl.currExperiment.status == ctrl.origStatus[0];
    };
    NewLearningPlanComponent.prototype.getDefined = function () {
        var ctrl = this;
        var total = 8;
        var done = 0;
        if (ctrl.currExperiment.expName)
            done++;
        if (ctrl.currExperiment.needToLearn)
            done++;
        if (ctrl.currExperiment.goingToLearn)
            done++;
        if (ctrl.currExperiment.toMeasure)
            done++;
        if (ctrl.currExperiment.successCriteria)
            done++;
        if (ctrl.currExperiment.cost)
            done++;
        if (ctrl.currExperiment.duration)
            done++;
        if (ctrl.currExperiment.resourceFte)
            done++;
        return Math.round((done * 100) / total);
    };
    NewLearningPlanComponent.prototype.onStChange = function (stickyData, key) {
        var ctrl = this;
        var calcImpactValues = ctrl.utilsService.calcImpactValues;
        stickyData.abilityToLaunch.key = stickyData.abilityToLaunch.key == key ? 'default' : key;
        if (stickyData.impactMappingList == 'default') {
            stickyData.calcImpact = calcImpactValues[stickyData.abilityToLaunch.key];
        }
        else {
            if (ctrl.radioOrCheckbox == 'radio') {
                stickyData.calcImpact = this.getCalculatedImpact(stickyData.impactMappingList[0]['display']);
            }
            else if (ctrl.radioOrCheckbox == 'checkbox') {
                stickyData.calcImpact = this.getCalculatedImpactCheckbox(stickyData.impactMappingList);
            }
            stickyData.calcImpact = calcImpactValues[stickyData.abilityToLaunch.key] > (stickyData.calcImpact || 0) ?
                calcImpactValues[stickyData.abilityToLaunch.key] : (stickyData.calcImpact || 0);
        }
        var impactToBeUsed = ctrl.isQualitative ? stickyData.impact : stickyData.calcImpact;
        stickyData.score = impactToBeUsed * stickyData.ignorance;
        ctrl.checkSave();
        // ctrl.saveCurrentExp();
    };
    NewLearningPlanComponent.prototype.onPStopperChange = function (stickyData) {
        var ctrl = this;
        stickyData.isPotentialShowStopper = !stickyData.isPotentialShowStopper;
        ctrl.checkSave();
        // ctrl.saveCurrentExp();
    };
    NewLearningPlanComponent.prototype.getCalculatedImpactCheckbox = function (rangeArr) {
        var ctrl = this;
        var scores = [];
        rangeArr.forEach(function (range) {
            var npvSwing = ctrl.utilsService.getNpvSwing(range.display, ctrl.npvData);
            var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
            var finalScore = Math.round((npvSwing / npvMax) * 8.99 + 0.5);
            scores.push(finalScore);
        });
        return rangeArr.length > 0 ? Math.max.apply(Math, scores) : null;
    };
    NewLearningPlanComponent.prototype.getCalculatedImpact = function (display) {
        var ctrl = this;
        var npvSwing = ctrl.utilsService.getNpvSwing(display, ctrl.npvData);
        var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
        return Math.round((npvSwing / npvMax) * 8.99 + 0.5);
    };
    NewLearningPlanComponent.prototype.getIssueDetailsFromDb = function () {
        var _this = this;
        var ctrl = this;
        ctrl.smartorg.getInavIssueForLearning(ctrl.node['_id']).then(function (res) {
            if (res.status == 1) {
                ctrl.stopLoadingSpinner();
                ctrl.showAlert('danger', 'Error!', res.message);
            }
            else {
                var allIssues_1 = [];
                // Iterate objects
                Object.keys(res['NColCanvasSwotData']).forEach(function (key) {
                    res['NColCanvasSwotData'][key].forEach(function (issue) {
                        allIssues_1.push(issue);
                    });
                });
                // Use the shared utility method to determine mode
                var modeConfig = ctrl.utilsService.determineQualitativeMode(res, ctrl.node);
                ctrl.isQualitative = modeConfig.isQualitative;
                ctrl.issueData = allIssues_1.map(function (item) { return _this.utilsService.formatIssueData(item, ctrl.isQualitative, ctrl.fteGlobal); });
                ctrl.distInputs = res['ColHeaders'];
                ctrl.inputTypeLt = res['RadioOrCheckBox'];
                ctrl.radioOrCheckbox = res['RadioOrCheckBox'];
                ctrl.npvData = res['NPVSwing'];
                ctrl.issueData.sort(function (a, b) { return (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0); });
                ctrl.showGenerateBtn = true;
                ctrl.menu = [];
                ctrl.stopLoadingSpinner();
                ctrl.$scope.$apply();
                ctrl.showTable(ctrl.issueData);
            }
        })["catch"](function (err) {
            ctrl.stopLoadingSpinner();
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    NewLearningPlanComponent.prototype.initSelectFactors = function () {
        var ctrl = this;
        if (ctrl.currExperiment.issueFactor) {
            if (ctrl.currExperiment.impactMappingList && ctrl.currExperiment.impactMappingList != "default") {
                var selectedFactorIndex = ctrl.currExperiment.impactMappingList.findIndex(function (f) { return (ctrl.currExperiment.issueFactor.key === f.key); });
                ctrl.selectedFactor = ctrl.currExperiment.impactMappingList[selectedFactorIndex];
            }
        }
        else {
            ctrl.selectedFactor = undefined;
        }
    };
    NewLearningPlanComponent.prototype.initSelectStatus = function () {
        var ctrl = this;
        if (ctrl.currExperiment.status) {
            var selectedStatusIndex = ctrl.origStatus.findIndex(function (f) { return (ctrl.currExperiment.status === f); });
            ctrl.selectedStatus = ctrl.origStatus[selectedStatusIndex];
        }
        else {
            ctrl.selectedStatus = undefined;
        }
    };
    NewLearningPlanComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.selectedIssue = null;
        ctrl.selectedIssueForComp = null;
        ctrl.isDirty = false;
    };
    NewLearningPlanComponent.prototype.selectIssueForActive = function (index, from) {
        var ctrl = this;
        ctrl.selectedForAct = index;
        ctrl.selectedFrom = from;
        ctrl.selectedIndex = index;
        var selectedIssue = ctrl.selectedFrom[index];
        selectedIssue.startExp = 'startActiveDate' in selectedIssue && selectedIssue.startActiveDate !== "" && !isNaN(new Date(selectedIssue.startActiveDate).getTime()) ? new Date(selectedIssue.startActiveDate) : '',
            ctrl.currExperiment = angular.copy(ctrl.utilsService.getIssueDetails(selectedIssue, ctrl.fteGlobal));
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.setWarningDialog();
        ctrl.$scope.$apply();
    };
    NewLearningPlanComponent.prototype.selectIssueForBacklog = function (index) {
        var ctrl = this;
        ctrl.selectedForAct = index;
        ctrl.selectedFrom = ctrl.inPlanData;
        ctrl.selectedIndex = index;
        var selectedIssue = ctrl.selectedFrom[index];
        ctrl.currExperiment = angular.copy(ctrl.utilsService.getIssueDetails(selectedIssue, ctrl.fteGlobal));
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.setMoveWarningDialog(ctrl.addInBacklog);
        // ctrl.addInBacklog()
        ctrl.$scope.$apply();
    };
    NewLearningPlanComponent.prototype.setSelection = function () {
    };
    NewLearningPlanComponent.prototype.selectIssueForInPlan = function (index, from) {
        var ctrl = this;
        ctrl.selectedForAct = index;
        ctrl.selectedFrom = from;
        ctrl.selectedIndex = index;
        var selectedIssue = ctrl.selectedFrom[index];
        ctrl.currExperiment = angular.copy(ctrl.utilsService.getIssueDetails(selectedIssue, ctrl.fteGlobal));
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.setMoveWarningDialog(ctrl.addInInPlan);
        // ctrl.addInInPlan()
        ctrl.$scope.$apply();
    };
    NewLearningPlanComponent.prototype.selectIssue = function (index, from) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssue = from[index];
        ctrl.selectedID = from[index]['_id'];
        ctrl.selectedFrom = from;
        $("#experimentInput").focus();
        ctrl.currExperiment = angular.copy(ctrl.utilsService.getIssueDetails(ctrl.selectedIssue, ctrl.fteGlobal));
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.initSelectFactors();
        ctrl.initSelectStatus();
        ctrl.expSelected = true;
        ctrl.$scope.$apply();
    };
    NewLearningPlanComponent.prototype.selectIssueForCompleted = function (index, from) {
        var ctrl = this;
        ctrl.selectedIndex = index;
        ctrl.selectedIssueForComp = from[index];
        ctrl.selectedID = from[index]['_id'];
        ctrl.selectedFrom = from;
        $("#experimentInput").focus();
        ctrl.currExperiment = angular.copy(ctrl.utilsService.getIssueDetails(ctrl.selectedIssueForComp, ctrl.fteGlobal));
        ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
        ctrl.initSelectFactors();
        ctrl.initSelectStatus();
        ctrl.expSelected = true;
        ctrl.$scope.$apply();
    };
    NewLearningPlanComponent.prototype.updateCurrExp = function () {
        var ctrl = this;
        ctrl.expSelected = true;
        ctrl.checkSave();
    };
    NewLearningPlanComponent.prototype.updateIterPlanInIssueData = function () {
        var ctrl = this;
        var updatedIssueData = angular.copy(ctrl.issueData);
    };
    NewLearningPlanComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.currExperiment = angular.copy(ctrl.origCurrExperiment);
        ctrl.clearSelection();
    };
    NewLearningPlanComponent.prototype.saveCurrentExp = function () {
        var ctrl = this;
        ctrl.currExperiment['initLearningPlanSection'] = ctrl.initLearningPlanSection;
        ctrl.updatedIssueData = ctrl.utilsService.updateIssueData(ctrl.selectedFrom, ctrl.selectedIndex, ctrl.currExperiment, ctrl.fteGlobal);
        ctrl.selectedFrom = angular.copy(ctrl.updatedIssueData);
        ctrl.saveExperimentData();
    };
    NewLearningPlanComponent.prototype.saveExperimentData = function () {
        var ctrl = this;
        var issueToBeSaved = angular.copy(ctrl.selectedFrom[ctrl.selectedIndex]);
        var experimentToBeSaved = angular.copy(issueToBeSaved['experimentData'][0]);
        if (experimentToBeSaved['_id'] == '') {
            delete experimentToBeSaved['_id'];
        }
        this.smartorg.saveInavExperimentData(issueToBeSaved['_id'], experimentToBeSaved).then(function (res) {
            if (res.status == 0) {
                ctrl.isDirty = false;
                ctrl.setGlobalDirty();
                ctrl.origCurrExperiment = angular.copy(ctrl.currExperiment);
                ctrl.showAlert('success', 'Saved!', 'Details saved for issue "' +
                    ctrl.selectedFrom[ctrl.selectedIndex]['name'] + '"');
                ctrl.clearSelection();
                ctrl.closeWarningDialog();
                // ctrl.clearDivs()
                ctrl.isDataLoaded = false;
                ctrl.issueData = [];
                ctrl.compltData = [];
                ctrl.inPlanData = [];
                ctrl.activeData = [];
                ctrl.backlogData = [];
                ctrl.unPlannedData = [];
                ctrl.getIssueDetailsFromDb();
                ctrl.$scope.$apply();
            }
            else {
                ctrl.showAlert('danger', 'Error!', res.message);
            }
        })["catch"](function (err) {
            ctrl.showAlert('danger', 'Error!', err.message);
        });
    };
    NewLearningPlanComponent.prototype.onFteChange = function () {
        var ctrl = this;
        ctrl.utilsService.onFteChange(ctrl.currExperiment, ctrl.fteGlobal, function () { ctrl.checkSave(); });
    };
    NewLearningPlanComponent.prototype.checkSave = function () {
        var ctrl = this;
        ctrl.isDirty = this.utilsService.checkSave(ctrl.currExperiment, ctrl.origCurrExperiment);
        ctrl.setGlobalDirty();
    };
    return NewLearningPlanComponent;
}());
angular.module('smartorg.r6.acts.newLearningPlan', []).component('newLearningPlan', {
    template: require('./new-learning-plan.component.html'),
    controller: NewLearningPlanComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.newLearningPlan';
//# sourceMappingURL=new-learning-plan.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/learning-plan-new/new-learning-plan.component.js